var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3905 12.5476L11.1092 10.2663C13.017 7.93975 12.8842 4.49287 10.703 2.31318C8.39045 -0.00087899 4.6342 -0.00087899 2.31233 2.31318C-0.00173348 4.63506 -0.00173348 8.39131 2.31233 10.7038C4.49202 12.8851 7.93889 13.0179 10.2655 11.1101L12.5467 13.3913C12.5967 13.4351 12.6764 13.4351 12.7186 13.3913L13.3905 12.7194C13.4342 12.6772 13.4342 12.5976 13.3905 12.5476ZM9.87483 9.87568C8.01858 11.7304 5.01233 11.7304 3.15608 9.87568C1.30139 8.01943 1.30139 5.01318 3.15608 3.15693C5.01233 1.30225 8.01858 1.30225 9.87483 3.15693C11.7295 5.01318 11.7295 8.01943 9.87483 9.87568Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e16161f1eeba91bd952aa039d4b522aa.svg";
export { ForwardRef as ReactComponent };